import { app } from '../../../../../app';
import { Controller } from './delete-accounts.controller';

app.component('companySharingCenterSharedAuthenticatorsDelete', {
    bindings: {
        accounts: '<',
        companyId: '<'
    },
    controller: Controller,
    templateUrl: require('./delete-accounts.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-authenticators/delete/delete-accounts.component.js